export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7517.3b3fa0c3.jpg";